import { render, staticRenderFns } from "./ftu.vue?vue&type=template&id=61039386&scoped=true"
import script from "./ftu.vue?vue&type=script&lang=js"
export * from "./ftu.vue?vue&type=script&lang=js"
import style0 from "./ftu.vue?vue&type=style&index=0&id=61039386&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61039386",
  null
  
)

export default component.exports